<template>
  <div class='JZContainer'>
    <div class="top">
      <el-button type="primary" @click="handleAddGroup">添加属性组</el-button>
    </div>
    <div class="container" v-if="targetLists && targetLists.length" style="border:1px solid #efefef;display: flex;background:#FFFFFF;height: calc(100vh - 240px);">
      <el-card class="box-card" v-for="info in targetLists" :key="info.id" shadow="hover" style="display: flex;flex-direction: column;">
        <div slot="header" class="clearfix" style="display:flex;align-items:center;padding: 0;">
          <span style="flex:1;">{{ info.attributeGroupName }}</span>
          <div style="float: right; ">
            <el-button type="text" style="font-size: 14px;" @click="handleEditGroup(info)" icon="el-icon-edit"></el-button>
            <el-button type="text" style="font-size: 14px;margin-left:2px;color:#F56C6C;" @click="handleDeleteGroup(info)" icon="el-icon-delete"></el-button>
          </div>
        </div>
        <div v-if="info.itemList && info.itemList.length" style="flex:1">
          <div v-for="item in info.itemList" :key="item.id" class="text item" style="display:flex">
            <div class="left">
              <div class="left_top" style="font-size: 16px;line-height: 30px;">
                {{ item.attributeName }}
              </div>
              <div class="left_content" style="font-size: 14px;line-height: 24px;">
                {{ item.attributeTypeDesc }}&nbsp;&nbsp;{{ item.specFlag === 1 ? '规格项' : '非规格项' }}
              </div>
            </div>
            <div class="right">
              <el-button type="text" style="font-size: 14px;" @click="handleEditAttribute(item, info)" icon="el-icon-edit"></el-button>
              <el-button type="text" style="font-size: 14px;margin-left:2px;color:#F56C6C;" @click="handleDeleteAttribute(item, info)" icon="el-icon-delete"></el-button>
            </div>
          </div>
        </div>
        <div v-else style="text-align:center;font-size:14px;" class="noEmptyContainer">
          暂无数据
        </div>
        <div class="text" style="text-align:center;">
          <el-button type="text" style="font-size: 14px;" @click="handleAddItems(info)" icon="el-icon-circle-plus-outline">添加</el-button>
        </div>
      </el-card>
    </div>
    <div v-else class="container">
      <el-empty description="暂无数据"></el-empty>
    </div>
    <EditAttributeGroup ref="JZEditAttributeGroup" @initPage="initPage"></EditAttributeGroup>
    <EditAttribute ref="JZEditAttribute" @initPage="initPage"></EditAttribute>
    <EditAttributeItem ref="JZEditAttributeItem" @initPage="initPage"></EditAttributeItem>
    <bottom-panel>
      <el-button @click="handleClose" style="margin-left: 10px;">取  消</el-button>
    </bottom-panel>
  </div>
</template>
<script>
import { getCategoryAttributeGroupPageList, deleteAttributeGroup, deleteAttributeItem } from '@/api/PlatformSales/Category.js';
import EditAttributeGroup from './component/editAttributeGroup.vue';
import EditAttributeItem from './component/EditAttributeItem.vue';
import EditAttribute from './component/EditAttribute.vue';
export default {
  name: '',
  components: {
    EditAttributeGroup,
    EditAttribute,
    EditAttributeItem,
  },
  props: {
    id: {
      type: String,
      default () {
        return '';
      },
    },
  },
  methods: {
    handleEditAttribute (item, info) {
      this.$refs.JZEditAttributeItem.JZForm = {
        required: item.required,
        isIndex: item.isIndex,
        specFlag: item.specFlag,
        sort: item.sort,
        attributeGroupId: info.attributeGroupId,
        attributeId: item.attributeId,
        attributeName: item.attributeName,
        categoryId: this.id,
        id: item.id,
      };
      this.$refs.JZEditAttributeItem.initPage();
    },
    handleDeleteAttribute (info) {
      this.$confirm(`确认删除【${info.attributeName}】？`, '确定删除').then(()=>{
        deleteAttributeItem({id: info.id}).then(() => {
          this.initPage();
        });
      });
    },
    handleAddGroup () {
      this.$refs.JZEditAttributeGroup.dialogTitle = '添加属性组';
      this.$refs.JZEditAttributeGroup.JZForm = {
        attributeGroupName: '',
      };
      this.$refs.JZEditAttributeGroup.currentId = this.id;
      this.$refs.JZEditAttributeGroup.currentAttributeGroupId = '';
      this.$refs.JZEditAttributeGroup.initPage();
    },
    handleEditGroup (info) {
      this.$refs.JZEditAttributeGroup.dialogTitle = '编辑属性组';
      this.$refs.JZEditAttributeGroup.currentId = this.id;
      this.$refs.JZEditAttributeGroup.currentAttributeGroupId = info.id;
      this.$refs.JZEditAttributeGroup.JZForm = {
        attributeGroupName: info.attributeGroupName,
      };
      this.$refs.JZEditAttributeGroup.initPage();
    },
    handleDeleteGroup (info) {
      this.$confirm(`确认删除【${info.attributeGroupName}】？`, '确定删除').then(()=>{
        deleteAttributeGroup({id: info.id}).then(() => {
          this.initPage();
        });
      });
    },
    handleAddItems (info) {
      this.$refs.JZEditAttribute.dialogTitle = '添加属性';
      this.$refs.JZEditAttribute.currentId = this.id;
      this.$refs.JZEditAttribute.currentAttributeGroupId = info.id;
      this.$refs.JZEditAttribute.selectedItemLists = info.itemList || [];
      this.$refs.JZEditAttribute.initPage();
    },
    initPage () {
      this.getAllCategoryBrandList();
    },
    getAllCategoryBrandList () {
      getCategoryAttributeGroupPageList({
        categoryId: this.id,
        pageFlag: false,
      }).then(({body}) => {
        this.targetLists = body.list || [];
        if (this.$route.query.currentAttributeGroupId) {
          this.$nextTick(() => {
            let info = this.targetLists.find(i => i.id === this.$route.query.currentAttributeGroupId);
            this.handleAddItems(info);
          });
        }
      });
    },
    handleClose () {
      this.$tabs.close({
        to: '/saas/platform/sales/platform/categories',
        refresh: true,
      });
    },
  },
  created () {
    this.initPage();
  },
  watch: {
    '$route.name': {
      deep: true,
      handler (val) {
        if (val === 'PlatformSales_PlatformCategories_BindAttribute') {
          this.initPage();
        }
      },
    },
  },
  data () {
    return {
      targetLists: [],
    };
  },
};
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
.JZContainer{
  background:#ffffff;
  height: calc(100vh - 100px);
  margin-bottom: 80px;
  .top{
    height: 40px;
    line-height: 40px;
    padding: 10px;
  }
}
/deep/.container{
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  min-height: 60vh;
  overflow-y: auto;
  .el-card{
    flex: 0 0 calc(20% - 12px); /* 每个项目占20%宽度减去间距 */
    margin: 5px;
    .el-card__body{
      flex: 1;
      padding: 5px;
      display: flex;
      flex-direction: column;
      .noEmptyContainer{
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #909399;
        font-size: 12px;
        min-height: 100px;
      }
      .item{
        padding: 0 5px;
        background: #F5F7FA;
        margin-bottom: 5px;
        display: flex;
        .left{
          flex:1;
          display: flex;
          flex-direction: column;
          .left_top{
            display: flex;
            align-items: center;
            line-height: 30px;
          }
          .left_content{
            display: flex;
            align-items: center;
            line-height: 30px;
          }
        }
        .right{
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
    .el-card__header{
      padding: 8px 10px;
    }
  }
}
</style>
